import {DText, FlexBetween, FlexCenter, HText, Padding} from "../../styles/CommonStyles";
import {useMainContext} from "../../contexts/main";
import {useOrderPercentage, useTradeHeaderHook} from "../../hooks/useTradeHeaderHook";
import {ChangePairIcon} from "../../styles/responsive/CommonStyles";
import {formatNumber, getPairInMobileVariants} from "../../utils/common";
import {OrdersPercentBars} from "../OrdersPercentage";
import {AnimatePresence} from "framer-motion";
import {PairsMobileBox, PairsTabletBox} from "../../styles/PairBoxStyles";
import Pairs from "../pairbox/Pairs";


const RMarketChanges = () => {


    const { market, main: {lang} } = useMainContext()
    const {
        onMarketNameClicked,
        currentChange,
        pairsInTabletMode
    } = useTradeHeaderHook()

    const {
        ordersAmount
    } = useOrderPercentage()

    return (
        <Padding padding="15px 0" style={{ position: "relative" }}>
            <FlexCenter>
                <FlexCenter width="50%">
                    <Padding padding="0 15px">
                        <OrdersPercentBars ordersAmount={ordersAmount} />
                    </Padding>
                </FlexCenter>

                <FlexCenter width="50%">
                    <Padding padding="0 15%">
                        <FlexBetween>
                            <DText
                                _type="number"
                                color={
                                    currentChange?._24change > 0 ? "#1ce087" : "#e9106c"
                                }>
                                {formatNumber(currentChange?._24change, 2)}%
                            </DText>
                            <HText>
                                {`${market.coin?.toUpperCase()}/${market.pair?.toUpperCase()}`}
                            </HText>
                            <ChangePairIcon onClick={onMarketNameClicked} />
                        </FlexBetween>
                    </Padding>
                </FlexCenter>
            </FlexCenter>
            <AnimatePresence>
                {pairsInTabletMode &&
                    <PairsMobileBox variants={getPairInMobileVariants(lang)} animate="in" exit="out" initial="out">
                        <Pairs />
                    </PairsMobileBox>
                }
            </AnimatePresence>
        </Padding>

    )
}

export default RMarketChanges;